<template>
    <div class="w-100" id="DataTableAcuerdosClientes">
      <!-- Contenido de la tabla -->
      <div :class="load ? 'd-block w-100' : 'd-none'">
        <Loading />
      </div>


      <div :class="load ? 'd-none' : 'd-block w-100'" >
        <table
          class="table table-bordered stripe display compact hover"
          :id="nombreTabla"
        >
        <thead>
          <tr>
            <template v-if="!customHeaders">
              
              <th
                v-for="(item, index_header) in headers"
                :key="index_header.title"
                class="text-center bg-light"
              >
                {{ item }}
              </th>
            </template>
            <template v-else>
              <th
                v-for="(item, index_header) in headers"
                :key="index_header"
                class="text-center bg-light"
                :style="{ width: item.width }"
              >
                {{ item.title }}
              </th>
            </template>
          </tr>
        </thead>
    
          <tbody>

            <template >
              <tr v-for="(item,index) in data" :key="index">
                <td
                  style="text-align: center; font-size: 11px"
                  v-text="index + 1"
                ></td>
                <td style="font-size: 11px !important">
                  <ui-select
                    class="p-0 mt-2"
                    has-search
                    placeholder="Seleccionar"
                    searchPlaceholder="Buscar"
                    :options="clientes"
                    v-model="item.cliente_id"
                    :keys="{ value: 'id', label: 'name' }"
                  />
                </td>
                <td style="font-size: 11px !important">
                  <ui-select
                    class="p-0 mt-2"
                    has-search
                    placeholder="Seleccionar"
                    searchPlaceholder="Buscar"
                    :options="navieras"
                    v-model="item.naviera"
                    :keys="{ value: 'id', label: 'name' }"
                  />
                </td>

                <td style="font-size: 11px !important">
                  {{ item.naviera_salida }}
                </td>

                <td style="font-size: 11px !important">
                  <ui-select
                    class="p-0 mt-2"
                    has-search
                    placeholder="Seleccionar"
                    searchPlaceholder="Buscar"
                    :options="puertos"
                    v-model="item.pol"
                    :keys="{ value: 'id', label: 'name' }"
                  />
                </td>

                <td style="font-size: 11px !important">
                  <ui-select
                    class="p-0 mt-2"
                    has-search
                    placeholder="Seleccionar"
                    searchPlaceholder="Buscar"
                    :options="puertos"
                    v-model="item.pod"
                    :keys="{ value: 'id', label: 'name' }"
                  />
                </td>

                <td>
                  <date-picker
                    placeholder="Fecha"
                    type="date"
                    class="w-100 p-0 mb-3 mr-3 input_fecha mt-2"
                    value-type="format"
                    v-model="item.from_date"
                  />
                </td>
                <td>
                  <date-picker
                    placeholder="Fecha"
                    type="date"
                    class="w-100 p-0 mb-3 mr-3 input_fecha mt-2"
                    value-type="format"
                    v-model="item.to_date"
                  />
                </td>
                <td>                
                  
                  <date-picker
                    placeholder="Vigencia"
                    type="date"
                    class="w-100 p-0 mb-3 mr-3 input_fecha mt-2"
                    value-type="format"
                    v-model="item.vigencia"
                  />

                </td>
                <td width="25px">
                  <input
                    class="w-100 p-0 form-control"
                    placeholder="TT"
                    v-model="item.transit_time"
                    disabled
                  />

                </td>

                <td>
                  <input
                    class="w-100 p-0 form-control"
                    placeholder="Pública (Venta)"
                    v-model="item.public_value"
                    v-mask="decimalMask"
                    disabled

                  />

                </td>

                <td>
                  <input
                    class="w-100 p-0 form-control"
                    placeholder="Neta (Costo)"
                    v-model="item.neta_cliente"
                    v-mask="decimalMask"
                    disabled

                  />
                </td>

                <td>
                  <input
                    class="w-100 p-0 form-control"
                    placeholder="Margen"
                    v-mask="marginMask"
                    v-model="item.commercial_margin"
                  />
            
                </td>

                <td>
                  <input
                    class="w-100 p-0 form-control"
                    placeholder="Margen"
                    v-model="item.neta_cliente"
                    v-mask="marginMask"
                    disabled
                  />

                </td>
                <td>
                  <input
                    v-model="item.descuento"
                    disabled
                    class="w-100 p-0 form-control"
                  />
                </td>
                <td>
                  <ui-select
                    class="p-0 mt-2"
                    has-search
                    placeholder="Seleccionar"
                    searchPlaceholder="Buscar"
                    v-model="item.container_id"
                    :options="contenedores"
                    :keys="{ value: 'id', label: 'name' }"
                  />
                </td>

                <td>
                  <ui-select
                    class="p-0 mt-2"
                    has-search
                    placeholder="Seleccionar"
                    searchPlaceholder="Buscar"
                    :options="commodity"
                    v-model="item.products_category_id"
                    :keys="{ value: 'id', label: 'name' }"
                  />
                </td>

                <td>
                  <ui-select
                  class="p-0 mt-2"
                    has-search
                    placeholder="Seleccionar"
                    searchPlaceholder="Buscar"
                    :options="atmosferas"
                    v-model="item.atmosphere_id"
                    :keys="{ value: 'id', label: 'name' }"
                  />
                </td>
                <td>
                  <ui-select
                    class="p-0 mt-2"
                    has-search
                    placeholder="Seleccionar"
                    searchPlaceholder="Buscar"
                    :options="filtroColdtreatment"
                    v-model="item.coldtreatment"
                    :keys="{ value: 'id', label: 'name' }"
                  />
                </td>

                <td>
                  <input
                    class="w-100 p-0 form-control"
                    placeholder="FDE"
                    v-model="item.free_days_embark"
                    disabled

                  />

                </td>
                <td>
                  <input
                    class="w-100 p-0 form-control"
                    placeholder="PDE"
                    v-model="item.plug_days_embark"
                    disabled

                  />

                </td>
                <td>
                  <input
                    class="w-100 p-0 form-control"
                    placeholder="FDL"
                    v-model="item.free_days_land"
                    disabled

                  />

                </td>
                <td>
                  <input
                    class="w-100 p-0 form-control"
                    placeholder="PGL"
                    v-model="item.plug_days_land"
                    disabled

                  />

                </td>
                <td>
                  <input
                      type="checkbox"
                      v-model="item.genset"
                      style="align-items: center; margin: 17px 0px 0px 2px;"
                    />
                </td>
                <td style="font-size: 11px !important">
                  {{ item.get_out }}
                </td>
                <td>
                  <textarea
                    class="w-100 p-0 form-control"
                    placeholder="Comentarios"
                    v-model="item.comment"
                  />
                </td>
                <td>
                  <ui-select
                    class="p-0 mt-2"
                    has-search
                    placeholder="Seleccionar"
                    searchPlaceholder="Buscar"
                    :options="tipoContratos"
                    v-model="item.tipo_contrato_id"
                    :keys="{ value: 'id', label: 'name' }"
                    disabled

                  />
                </td>
                <td>
                  <ui-select
                    class="p-0 mt-2"
                    has-search
                    placeholder="Seleccionar"
                    searchPlaceholder="Buscar"
                    :options="contratos"
                    v-model="item.tariff_contract"
                    :keys="{ value: 'id', label: 'name' }"
                    disabled

                  />
                </td>
              </tr>
                  
            </template>
          </tbody>
        </table>
      </div>

    </div>
  </template>
  
<script>
import { mapState, mapActions } from "vuex";

const decimalMask = createNumberMask({
  prefix: "",
  suffix: "",
  allowDecimal: true,
  requireDecimal: false,
  includeThousandsSeparator: false,
  decimalSymbol: ".",
  decimalLimit: 2,
  integerLimit: 6
});

const marginMask = createNumberMask({
    prefix: "",
    suffix: "",
    allowDecimal: true,
    requireDecimal: false,
    includeThousandsSeparator: false,
    decimalSymbol: ".",
    decimalLimit: 2,
    integerLimit: 6,
    allowNegative: true
  });
  
  // Importación de Jquery
  import $ from "jquery";
  import DatePicker from "vue2-datepicker";
  import Loading from "../../common/loading.vue";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
  
  export default {
    components: { DatePicker, Loading},
    // components: { UiTextbox },
    props: {
      check: Boolean, // Permite agregar un checkbox como primer elemento de la tabla, esta opción esta deshabilitada por defecto
      customHeaders: Boolean, // Permite asignar el ancho de cada cabecera mediante un array de configuración {title: '', width: ''}
      headers: Array, // Titulos para cabecera de la tabla
      data: Array, // Contenido o información que mostrara la tabla
      acciones: Array, // Array de configuraciones para botones de la columna "Acciones"
      paginacion: Boolean, // Si la tabla tedra activa la opción de paginación, esta opción esta deshabilitada por defecto
      max: { type: Number, default: 10 }, // Numero de filas por cada pagina
      buscar: Boolean, // Filtrar filas, esta opción esta deshabilitada por defecto
      idtabla: {
        type: String,
        default: "id_generico",
      },
      filtroColdtreatment: {
        type: Array,
        default: () => [],
      },
      load: Boolean
    },
  
    data() {
      return {
        decimalMask,
        marginMask,
        loading: true,
        lang: {
          lengthMenu: "Display _MENU_ records per page",
          zeroRecords: "No se encontraron registros coincidentes",
          info: "Mostrando página _PAGE_ de _PAGES_",
          infoEmpty: "No hay registros disponibles",
          infoFiltered: "(filtrado de _MAX_ registros totales)",
          search: "Buscar",
          paginate: {
            first: "Primero",
            last: "Ultimo",
            next: "Siguiente",
            previous: "Anterior",
          },
          buttons: {
            colvis: "Seleccionar columnas",
          },
        },
        nombreTabla: "id_tabla_" + this.idtabla,
        dataAux: this.data,
        accionesAux: this.acciones,
        flagFormulario: false,
        options: [],
        selected: [],
        selectAll: false,
      };
    },
    computed: {
      ...mapState("lineas", [
        "dataListaNaviera","dataListaProducto"
      ]),
      ...mapState("administracion", ["dataDatatableAtmosferas"]),
      ...mapState(["contratos","clientes","navieras","puertos","atmosferas","destinos","commodity","tipoContratos","contenedores", "estados"]),
    },
    methods: {
        cambiarEstadoCheck(event, id) {
            let estado = event.target.checked;
            let accion = "fila_chekeada";
            this.filaChekeada({ id, estado, accion });
        },
        cambiaValorDescuento (index ) {

            const descuento =  parseInt( this.data[index].public_value ) - parseInt( this.data[index].neta );
            this.data[index].descuento = ( descuento > 0 ) ? descuento : 0 ;
        },
  
        select() {
            this.selected = [];
            if (!this.selectAll) {
                for (let i in this.options) {
                    this.selected.push(this.options[i]);
                }
            }
        },
  
      updateCheckall: function () {
        if (this.options.length == this.selected.length) {
          this.selectAll = true;
        } else {
          this.selectAll = false;
        }
      },
  
      cambiarEstadoTodosCHECK() {
        console.log(this.dataAux);
  
        
      },
  
      // Acciones de Vuex
      ...mapActions(["ActionSetLoading"]),
  
      filaSeleccionada(id, accion) {
        this.seleccionar({ id, accion });
      },
  
      configuracionDatatable() {
        let me = this;
  
        $("#" + this.nombreTabla)
          .DataTable()
          .destroy();
  
        $("#" + me.nombreTabla)
          .DataTable({
            paging: this.paginacion,
            pageLength: this.max,
            searching: this.buscar,
            lengthChange: false,
            ordering: true,
            info: true,
            autoWidth: false,
            responsive: true,
            checkd: false,
            language: me.lang,
          })
          .buttons()
          .container()
          .appendTo("#" + me.nombreTabla + "_wrapper .col-md-6:eq(0)");
  
        $(".exportar-tabla").click(() => {
          $("#" + me.nombreTabla)
            .DataTable()
            .buttons(2 - 1)
            .trigger();
        });
      },
    },
  
    mounted() {
      let me = this;
      me.configuracionDatatable();
    },
  
    watch: {
      data: function (_new) {
        let me = this;
  
        // Si watch detecta un cambio en la variable dataDatatableFilialesFiltrada la cual es un state de vuex, esta asignada el nuevo
        // valor a la variable data
        if (_new) {
          // Se debe destruir la tabla para cargar nuevos datos
          $("#" + this.nombreTabla)
            .DataTable()
            .destroy();
  
          setTimeout(() => {
            me.dataAux = _new;
          }, 300);
  
          setTimeout(() => {
            me.configuracionDatatable();
            me.ActionSetLoading(false);
          }, 700);
        }
      },
  
      acciones: function (_new) {
        if (_new) {
          this.accionesAux = _new;
        }
      },
  
      cambiarEstadoTodosCHECK: function (_new) {
        if (_new) {
          this.cambiarEstadoTodosCHECK = _new;
        }
      },
    },
  };
  </script>
  
<style scoped>

#DataTableAcuerdosClientes .mx-datepicker {
  width: 105px;
}

#DataTableAcuerdosClientes .table {
  font-size: 11px;
}

</style>
  